import React, { useState, useEffect } from 'react';
import { app } from '../firebase'; // Importez votre configuration Firebase
import { getFirestore, collection, onSnapshot, query, where, orderBy } from 'firebase/firestore'; 
import Loader from '../components/Loader';
import { isProvider, useUser } from '../contexts/UserContext';
import { datetimeFromTimestampToString } from '../librairies/Dates';
import TextModal from '../components/modals/TextModal';
import {Icon} from 'react-icons-kit';
import {filter} from 'react-icons-kit/feather/filter';
import DetailsEvent from './DetailsEvent';
import { rentalManagerCanMakeActionOnCoownership } from '../librairies/UsersLib';
import { isRentalManager } from '../contexts/UserContext';
import AppDisplayPreview from '../components/AppDisplayPreview';
import evenementsPreview from '../assets/images/app-display/evenements.jpeg';

const db = getFirestore(app);

const ListEvents = ({ onSelectDate, setMenu }) => {

  const [events, setEvents] = useState([]); 
  const [loader, setLoader] = useState(true);

  const [showTextModal, setShowTextModal] = useState(false); 
  const [descriptionToShow, setDescriptionToShow] = useState(null); 
  const [expandedEventId, setExpandedEventId] = useState(null);
  const [selectedFilesEvent, setSelectedFilesEvent] = useState(null);
  const [filterDate, setFilterDate] = useState(true); 
  const [filterProvider, setFilterProvider] = useState(false);

  //contexte de l'utilisateur connecté
  const user = useUser();


  useEffect(() => {
    const collectionRef = collection(db, user.user.userData.lastCoownershipLoaded.path+"/events");

    // Ajouter la condition where
    const q = query(collectionRef, where("status", "==", "accepted"), 
        ...(filterDate ? [orderBy("dateBegining", "desc")] : []),
        ...(filterProvider && !filterDate ? [orderBy("firstnameCreator")] : []));

    const unsubscribe = onSnapshot(q, (snapshot) => {

      if(snapshot.docs.length > 0){
        
        let arr = [];

        snapshot.docs.map((event) => {

          if(isProvider(user.user) && event.data().idCreator.path != "users/"+user.user.user.uid){
            return;
          }

          //on n'affiche pas l'event s'il est destiné aux membres du CS et que le compte est un rentalManager qui ne peut pas créé de contenu sur la copropriété
          if(isRentalManager(user.user) && !rentalManagerCanMakeActionOnCoownership(user.user) && event.data().coownershipComiteeTarget && !event.data().coownerTarget && !event.data().tenantTarget){
            return;
          }

          let obj = {
            id: event.id, 
            title: event.data().title, 
            description: event.data().description, 
            firstname: event.data().firstnameCreator,
            lastname: event.data().lastnameCreator,
            dateBegining: event.data().dateBegining.seconds,
            dateEnd: event.data().dateEnd.seconds,
            files: event.data().files || [],
            coownershipComiteeTarget: event.data().coownershipComiteeTarget,
            coownerTarget: event.data().coownerTarget,
            tenantTarget: event.data().tenantTarget,
          }

          arr.push(obj);
        });
        
        setEvents(arr);
      }

      setLoader(false);
    });

    return () => {
      console.log("unsubscribe claims");
      unsubscribe();
    }
  }, [filterDate, filterProvider]); 


  useEffect(() => {
    if(showTextModal === false){
      setDescriptionToShow(null);
    }
  }, [showTextModal]);

  useEffect(() => {
    if(descriptionToShow != null){
      setShowTextModal(true); 
    }
  }, [descriptionToShow]);

  const displayCalendar = (event) => {
    onSelectDate(new Date(event.dateBegining * 1000));
    setMenu("calendrier");
  }

  const toggleExpandedEvent = (event) => {
    setExpandedEventId((currentId) => (currentId === event.id ? null : event.id));
  };


  return (
    <div>
      <div className="flex justify-end">
        <AppDisplayPreview image={evenementsPreview} label="Aperçu des événements dans l'application" />
      </div>
      {loader ? (
        <Loader />
      ) : (
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                    Titre
                </th>
                <th scope="col" className="px-6 py-3 cursor-pointer" onClick={() => setFilterDate(!filterDate)}>
                    Date Début
                    <span className={filterDate ? "text-primary" : "text-black"}>
                      <Icon className="ml-1" icon={filter} size={16} />
                    </span>
                </th>
                <th scope="col" className="px-6 py-3">
                    Date de Fin
                </th>
                <th scope="col" className="px-6 py-3 cursor-pointer" onClick={() => setFilterProvider(!filterProvider)}>
                    Prestataire
                    <span className={filterProvider ? "text-primary" : "text-black"}>
                      <Icon className="ml-1" icon={filter} size={16} />
                    </span>
                </th>
                <th scope="col" className="px-6 py-3">
                    Action
                </th>
              </tr>
            </thead>
            <tbody>
              {events.map((event, key) => {
                return (
                  <React.Fragment key={event.id ?? key}>
                  <tr
                    className={key % 2 === 0 ? "bg-white border-b dark:bg-gray-900 dark:border-gray-700" : "border-b bg-gray-50 dark:bg-gray-800 dark:border-gray-700"}
                    style={{ cursor: 'pointer' }}
                    onClick={() => toggleExpandedEvent(event)}
                  >
                    <td className="px-6 py-4">
                      {event.title}
                    </td>
                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                      {datetimeFromTimestampToString(event.dateBegining)}
                    </th>
                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                      {datetimeFromTimestampToString(event.dateEnd)}
                    </th>
                    <td className="px-6 py-4">
                      {event.firstname + " " + event.lastname}
                    </td>
                    <td className="px-6 py-4">
                      <div className='flex gap-4'>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setDescriptionToShow(event.description);
                          }}
                          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                        >
                          Afficher la description
                        </a>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            displayCalendar(event);
                          }}
                          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                        >
                          Afficher dans le calendrier
                        </a>
                      </div>
                    </td>
                  </tr>
                  {expandedEventId === event.id && (
                    <tr
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleExpandedEvent(event)}
                    >
                      <td colSpan={5} className="bg-gray-50 dark:bg-gray-800 p-4">
                        <div className="border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 p-4">
                          <p className="font-bold text-gray-900 dark:text-white">{event.title}</p>
                          <p className="text-sm text-gray-600 dark:text-gray-300">
                            Créé par {event.firstname + " " + event.lastname}
                          </p>
                          <p className="text-sm text-gray-600 dark:text-gray-300">
                            {datetimeFromTimestampToString(event.dateBegining)} - {datetimeFromTimestampToString(event.dateEnd)}
                          </p>

                          {(event.coownershipComiteeTarget !== undefined ||
                            event.coownerTarget !== undefined ||
                            event.tenantTarget !== undefined) && (
                            <p className="text-sm text-gray-600 dark:text-gray-300">
                              Cibles : {[
                                event.coownershipComiteeTarget ? "CS" : null,
                                event.coownerTarget ? "Copropriétaires" : null,
                                event.tenantTarget ? "Locataires" : null,
                              ].filter(Boolean).join(" - ")}
                            </p>
                          )}
                          
                          <p className="mt-3 whitespace-pre-wrap text-gray-800 dark:text-gray-200">
                            {event.description}
                          </p>

                          {event?.files && event.files.length > 0 && (
                            <div
                              className="flex items-center space-x-2 mt-4 pl-4 py-2 bg-blue-50 rounded-lg border border-blue-200 cursor-pointer hover:bg-blue-100 transition-colors"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setSelectedFilesEvent(event);
                              }}
                            >
                              <svg
                                className="w-5 h-5 text-blue-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                />
                              </svg>
                              <p className="text-blue-700 font-medium">
                                {event.files.length} fichier{event.files.length > 1 ? 's' : ''} attaché
                                {event.files.length > 1 ? 's' : ''}
                              </p>
                            </div>
                          )}

                          {selectedFilesEvent?.id === event.id && (
                            <div
                              className="mt-4"
                              onClick={(e) => {
                                // Evite que les clics du carrousel ferment la ligne
                                e.stopPropagation();
                              }}
                            >
                              <DetailsEvent
                                event={selectedFilesEvent}
                                onBack={() => setSelectedFilesEvent(null)}
                              />
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                  </React.Fragment>
                )
              })}
            </tbody>
          </table>
        </div>
      )}

      {showTextModal ? (
        <TextModal onClose={() => setShowTextModal(false)} text={descriptionToShow}/>
      ) : null }
    </div>
  );
};

export default ListEvents;
